import axios from "axios"
import { ADD_TO_CART, EMPTY_CART, REMOVE_FROM_CART, SAVE_SHIPPING_INFO, UPDATE_CART } from "../constants/cartConstants";

// add to cart
export const addItemsToCart = (id, quantity = 1, size) => async (dispatch, getState) => {
    const { data } = await axios.get(`/api/v1/product/${id}`);

    dispatch({
        type: ADD_TO_CART,
        payload: {
            product: data.product._id,
            name: data.product.name,
            brand: data.product.brand ? data.product.brand.name : "", // Ensure brand is always a string
            price: Number(data.product.price),
            mrp: Number(data.product.mrp),
            deliveryCharges: Number(data.product.deliveryCharges),
            image: data.product.images[0].highUrl,
            stock: data.product.stock,
            quantity,
            size,
        },
    });

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}

// get cart items
export const getCartItems = () => async (dispatch, getState) => {
    const { cartItems } = getState().cart;
    const updatedCartItems = [];

    for (const item of cartItems) {
        try {
            const { data } = await axios.get(`/api/v1/product/${item.product}`);
            const updatedItem = {
                ...item,
                name: data.product.name,
                brand: data.product.brand ? data.product.brand.name : "",
                price: Number(data.product.price),
                mrp: Number(data.product.mrp),
                deliveryCharges: Number(data.product.deliveryCharges),
                image: data.product.images[0].highUrl,
                stock: data.product.stock,
            };
            updatedCartItems.push(updatedItem);
        } catch (error) {
            // if product is not found, remove it from cart
            if (error.response && error.response.status === 404) {
                dispatch(removeItemsFromCart(item.product));
            }
        }
    }

    dispatch({
        type: UPDATE_CART,
        payload: updatedCartItems,
    });

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
};

// remove cart item
export const removeItemsFromCart = (id, size) => async (dispatch, getState) => {

    dispatch({
        type: REMOVE_FROM_CART,
        payload: { id, size },
    });

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}

// empty cart
export const emptyCart = () => async (dispatch, getState) => {

    dispatch({ type: EMPTY_CART });

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}

// save shipping info
export const saveShippingInfo = (data) => async (dispatch) => {

    dispatch({
        type: SAVE_SHIPPING_INFO,
        payload: data,
    });

    localStorage.setItem('shippingInfo', JSON.stringify(data));
}